import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getSupportingContent } from "../../services/clients";
import SupportingContentTable from "../../components/Tables/SupportingContentTable";

export const SupportingContent = () => {
  const { selectedClient } = useContext(AppContext);
  const [supportingContent, setSupportingContent] = useState([]);

  useEffect(() => {
    const fetchSupportingContent = async () => {
      try {
        setSupportingContent(
          await getSupportingContent(
            selectedClient.public_id ?? selectedClient.id
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    if (selectedClient) {
      fetchSupportingContent();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div style={{ width: "100%" }}>
      <SupportingContentTable supportingContent={supportingContent} />
    </div>
  );
};

export default SupportingContent;
